/** the mutation error is typed unknown, so the server's message has to be read through a cast */
export const errorMessage = (err: unknown, fallback: string) =>
  (err as { response?: { data?: { message?: string } } })?.response?.data
    ?.message ?? fallback;
